var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"d-flex align-center justify-center flex-column"},[_c('inline-svg',{attrs:{"src":require('@/assets/icons/bold/clipboard.svg')}}),_c('p',{staticClass:"mb-0 base-body-text mt-4 text-center"},[_vm._v(" "+_vm._s(_vm.title ? _vm.title : _vm.$t("shared.no-data"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }